import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const baseInfoAdultEducation = {
    grade: {
        queryList: config => createAPI('/baseInfoAdultEducation/gradeInfo/queryList', 'post', config),
        jxxzItem: config => createAPI('/baseInfoAdultEducation/gradeInfo/jxxzItem', 'post', config),
        save: config => createAPI('/baseInfoAdultEducation/gradeInfo/save', 'post', config),
        update: config => createAPI('/baseInfoAdultEducation/gradeInfo/update', 'post', config),
        del: config => createAPI('/baseInfoAdultEducation/gradeInfo/del', 'post', config),
    },
    major: {
        queryList: config => createAPI('/baseInfoAdultEducation/major/queryList', 'post', config),
        initCombo: config => createAPI('/baseInfoAdultEducation/major/initCombo', 'post', config),
        save: config => createAPI('/baseInfoAdultEducation/major/save', 'post', config),
        deleteById: config => createAPI('/baseInfoAdultEducation/major/deleteById', 'post', config),
        releaseRecById: config => createAPI('/baseInfoAdultEducation/major/releaseRecById', 'post', config),
        majorCategories: config => createAPI('/baseInfoAdultEducation/major/majorCategories', 'post', config),
    },
    course: {
        queryList: config => createAPI('/baseInfoAdultEducation/course/queryList', 'post', config),
        initOption: config => createAPI('/baseInfoAdultEducation/course/initOption', 'post', config),
        majorOption: config => createAPI('/baseInfoAdultEducation/course/majorOption', 'post', config),
        deleteById: config => createAPI('/baseInfoAdultEducation/course/deleteById', 'post', config),
        save: config => createAPI('baseInfoAdultEducation/course/save', 'post', config),
        updateAuditState: config => createAPI('baseInfoAdultEducation/course/updateAuditState', 'post', config),
        updateCourseState: config => createAPI('baseInfoAdultEducation/course/updateCourseState', 'post', config),
        queryAuditFlow: config => createAPI('baseInfoAdultEducation/course/queryAuditFlow', 'post', config),
        releaseRecById: config => createAPI('baseInfoAdultEducation/course/releaseRecById', 'post', config),
    },
    class: {
        queryList: config => createAPI('/baseInfoAdultEducation/class/queryList', 'post', config),
        export: config => createAPI('/baseInfoAdultEducation/class/export', 'post', config),
        item: config => createAPI('/baseInfoAdultEducation/class/item', 'post', config),
        stuCombo: config => createAPI('/baseInfoAdultEducation/class/stuCombo', 'post', config),
        jsItem: config => createAPI('/baseInfoAdultEducation/class/jsItem', 'post', config),
        teacherList: config => createAPI('/baseInfoAdultEducation/class/teacherList', 'post', config),
        studentList: config => createAPI('/baseInfoAdultEducation/class/studentList', 'post', config),
        classOrderNum: config => createAPI('/baseInfoAdultEducation/class/classOrderNum', 'post', config),
        save: config => createAPI('/baseInfoAdultEducation/class/save', 'post', config),
        deleteById: config => createAPI('/baseInfoAdultEducation/class/deleteById', 'post', config),
        upload: config => createAPI('/baseInfoAdultEducation/class/upload', 'post', config),
        loadMajorCombo: config => createAPI('/baseInfoAdultEducation/class/loadMajorCombo', 'post', config),
        batchExport: config => createAPI('/baseInfoAdultEducation/class/batchExport', 'post', config),
        saveAutoRec: config => createAPI('/baseInfoAdultEducation/class/saveAutoRec', 'post', config),
        allocationClassStudentList: config => createAPI('/baseInfoAdultEducation/class/allocationClassStudentList', 'post', config),//已经分班的学生
        removeAllocationClassStudentById: config => createAPI('/baseInfoAdultEducation/class/removeAllocationClassStudentById', 'post', config),
        allocationStudentList: config => createAPI('/baseInfoAdultEducation/class/allocationStudentList', 'post', config),//已经分班或未分班的学生
        allocationStudentSave: config => createAPI('/baseInfoAdultEducation/class/allocationStudentSave', 'post', config),
        checkInRec: config => createAPI('/baseInfoAdultEducation/class/checkInRec', 'post', config),
        saveAutoCheckInRec: config => createAPI('/baseInfoAdultEducation/class/saveAutoCheckInRec', 'post', config),
    },
    classroom: {
        queryList: config => createAPI('/baseInfoAdultEducation/classroom/queryList', 'post', config),
        item: config => createAPI('/baseInfoAdultEducation/classroom/item', 'post', config),
        save: config => createAPI('/baseInfoAdultEducation/classroom/save', 'post', config),
        deleteById: config => createAPI('/baseInfoAdultEducation/classroom/deleteById', 'post', config),
    },
    semester: {
        queryList: config => createAPI('/baseInfoAdultEducation/semester/queryList', 'post', config),
        save: config => createAPI('/baseInfoAdultEducation/semester/save', 'post', config),
        jcsj: config => createAPI('/baseInfoAdultEducation/semester/jcsj', 'post', config),
        xqxl: config => createAPI('/baseInfoAdultEducation/semester/xqxl', 'post', config),
        updateJcsj: config => createAPI('/baseInfoAdultEducation/semester/updateJcsj', 'post', config),
        saveHoliday: config => createAPI('/baseInfoAdultEducation/semester/saveHoliday', 'post', config),
    },
};

export default baseInfoAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/baseInfoAdultEducation.js